export {
  default as DownOutline
} from '@ant-design/icons/lib/outline/DownOutline';
export {
  default as PlusOutline
} from '@ant-design/icons/lib/outline/PlusOutline';
export {
  default as InfoCircleOutline
} from '@ant-design/icons/lib/outline/InfoCircleOutline';

// export what antd other components need
export {
  default as CloseOutline
} from '@ant-design/icons/lib/outline/CloseOutline';
export {
  default as CheckCircleOutline
} from '@ant-design/icons/lib/outline/CheckCircleOutline';
export {
  default as CloseCircleOutline
} from '@ant-design/icons/lib/outline/CloseCircleOutline';
export {
  default as NotificationOutline
} from '@ant-design/icons/lib/outline/NotificationOutline';
// calendar
export {
  default as CalendarOutline
} from '@ant-design/icons/lib/outline/CalendarOutline';

export {
  default as QuestionCircleOutline
} from '@ant-design/icons/lib/outline/QuestionCircleOutline';
// export {
//   default as CloseCircleOutlineSvg
// } from '@ant-design/icons/inline-svg/fill/close-cricle.svg';

export {
  default as InfoCircleFill
} from '@ant-design/icons/lib/fill/InfoCircleFill';

export {
  default as CheckCircleFill
} from '@ant-design/icons/lib/fill/CheckCircleFill';

export {
  default as CloseCircleFill
} from '@ant-design/icons/lib/fill/CloseCircleFill';

export {
  default as ExclamationCircleFill
} from '@ant-design/icons/lib/fill/ExclamationCircleFill';

export {
  default as LoadingOutline
} from '@ant-design/icons/lib/outline/LoadingOutline';

export {
  default as StarFill
} from '@ant-design/icons/lib/fill/StarFill';

export {
  default as LeftOutline
} from  '@ant-design/icons/lib/outline/LeftOutline'

export {
  default as RightOutline
} from  '@ant-design/icons/lib/outline/RightOutline'
